import { CloudUpload as UploadIcon } from '@mui/icons-material';
import { CircularProgress, Typography } from '@mui/material';
import React from 'react';

/** The upload dropzone's body: a spinner while uploading, otherwise the icon + hint text. */
export default function MediaUploadZoneContent({ uploading }: { uploading: boolean }) {
  if (uploading) {
    return (
      <>
        <CircularProgress size={22} />
        <Typography variant="caption">Uploading…</Typography>
      </>
    );
  }
  return (
    <>
      <UploadIcon sx={{ fontSize: 28 }} />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Drop videos here to add them to the library
      </Typography>
      <Typography variant="caption">or click to choose files</Typography>
    </>
  );
}
